import { mutator } from 'satcheljs';
import {
    onSharingLinkRetrivalFailure,
    onStartRetrievingSharingLink,
} from '../actions/internalActions';
import getInsertLinkViewState from '../selectors/getInsertLinkViewState';
import { InsertLinkFailureType } from '../types/InsertLinkFailureType';

mutator(onSharingLinkRetrivalFailure, actionMessage => {
    setIsRetrievingSharingLink(actionMessage.linkId, false, actionMessage.insertLinkFailureType);
});

mutator(onStartRetrievingSharingLink, actionMessage => {
    setIsRetrievingSharingLink(actionMessage.linkId, true, InsertLinkFailureType.Unknown);
});

function setIsRetrievingSharingLink(
    linkId: string,
    value: boolean,
    insertLinkFailureType: InsertLinkFailureType
) {
    const viewState = getInsertLinkViewState(linkId);
    if (viewState) {
        viewState.isRetrievingSharingLink = value;
        viewState.insertFailureType = insertLinkFailureType;
    }
}
